import { render, staticRenderFns } from "./hosCdata.vue?vue&type=template&id=0c110375&scoped=true&"
import script from "./hosCdata.vue?vue&type=script&lang=js&"
export * from "./hosCdata.vue?vue&type=script&lang=js&"
import style0 from "./hosCdata.vue?vue&type=style&index=0&id=0c110375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c110375",
  null
  
)

export default component.exports